<p8-page-block>
  <div class="p8-page-block-header">
    <span class="p8-secondary">{{ file?.name }}</span>
  </div>
  <div class="p8-page-block-content">
    <div fxLayout="column">
      <mat-form-field hintLabel="Donnez un titre plus adapté au document">
        <input matInput placeholder="Titre" [(ngModel)]="title">
      </mat-form-field>
    </div>
  </div>
</p8-page-block>
